(function(){
  var root=document.querySelector('[data-abc-pdp]');
  if(!root)return;

  /* Dynamic checkout is intentionally not part of the ClassWallet PDP. */
  root.querySelectorAll('.abc-buybox__shoppay').forEach(function(el){el.remove();});
  root.querySelectorAll('.abc-faq__more a').forEach(function(a){
    if(a.textContent.trim()==='See more FAQ')a.textContent='See more FAQs';
  });

  var main=root.querySelector('[data-gallery-main-img]');
  root.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var full=t.getAttribute('data-full');
      if(main&&full){main.src=full;main.srcset='';}
      root.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    });
  });
  var viewall=root.querySelector('[data-viewall]');
  if(viewall){viewall.addEventListener('click',function(){var g=root.querySelector('.abc-gallery__grid');if(g){g.querySelectorAll('[data-thumb][hidden]').forEach(function(x){x.hidden=false;});viewall.hidden=true;}});}
  var scroller=root.querySelector('.abc-gallery__scroller');
  if(scroller){
    var dots=root.querySelectorAll('.abc-gallery__dot');
    scroller.addEventListener('scroll',function(){
      var i=Math.round(scroller.scrollLeft/scroller.clientWidth);
      dots.forEach(function(d,n){d.classList.toggle('is-active',n===i);});
    },{passive:true});
  }
  root.querySelectorAll('[data-qty]').forEach(function(q){
    var input=q.querySelector('input');
    var minus=q.querySelector('[data-qty-minus]');
    var plus=q.querySelector('[data-qty-plus]');
    if(minus)minus.addEventListener('click',function(){input.value=Math.max(1,(parseInt(input.value,10)||1)-1);input.dispatchEvent(new Event('change',{bubbles:true}));});
    if(plus)plus.addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)+1;input.dispatchEvent(new Event('change',{bubbles:true}));});
  });
  root.querySelectorAll('[data-acc-btn]').forEach(function(b){
    b.addEventListener('click',function(){
      var panel=b.parentElement.querySelector('[data-acc-panel]');
      var open=b.getAttribute('aria-expanded')==='true';
      b.setAttribute('aria-expanded',open?'false':'true');
      if(panel)panel.classList.toggle('is-open',!open);
    });
  });
  root.querySelectorAll('[data-expand-all]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var wrap=btn.closest('.abc-faq')||root;
      var accs=wrap.querySelectorAll('[data-acc-btn]');
      var anyClosed=Array.prototype.some.call(accs,function(b){return b.getAttribute('aria-expanded')!=='true';});
      accs.forEach(function(b){
        b.setAttribute('aria-expanded',anyClosed?'true':'false');
        var panel=b.parentElement.querySelector('[data-acc-panel]');
        if(panel)panel.classList.toggle('is-open',anyClosed);
      });
      var txt=btn.querySelector('[data-ea-txt]');var sign=btn.querySelector('[data-ea-sign]');
      if(txt)txt.textContent=anyClosed?'Collapse All':'Expand All';
      if(sign)sign.textContent=anyClosed?'−':'+';
    });
  });

  function formatMoney(cents){
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'USD';
    var locale=document.documentElement.lang||'en-US';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format((Number(cents)||0)/100);}
    catch(e){return '$'+((Number(cents)||0)/100).toFixed(2);}
  }

  function ensurePriceElement(parent,selector,className){
    var el=parent?parent.querySelector(selector):null;
    if(!el&&parent){el=document.createElement('span');el.className=className;parent.appendChild(el);}
    return el;
  }

  function setVariant(variant){
    if(!variant)return;
    var price=formatMoney(variant.price);
    var compare=variant.compare_at_price&&Number(variant.compare_at_price)>Number(variant.price)?formatMoney(variant.compare_at_price):'';
    var available=variant.available!==false;

    root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input){input.value=variant.id;});

    if(variant.featured_image&&variant.featured_image.src){
      var variantSrc=variant.featured_image.src;
      if(main){main.src=variantSrc;main.srcset='';}
      var stickyImg=root.querySelector('.abc-stickybar__thumb img');
      if(stickyImg)stickyImg.src=variantSrc;
    }

    var priceWrap=root.querySelector('.abc-buybox__price');
    if(priceWrap){
      var current=ensurePriceElement(priceWrap,'.abc-price__current','abc-price__current');
      var compareEl=ensurePriceElement(priceWrap,'.abc-price__compare','abc-price__compare');
      var badge=ensurePriceElement(priceWrap,'.abc-price__badge','abc-price__badge');
      if(current)current.textContent=price;
      if(compareEl){compareEl.textContent=compare;compareEl.hidden=!compare;}
      if(badge){badge.textContent='Sale';badge.hidden=!compare;}
    }

    var mainButton=root.querySelector('.abc-buybox__form button[name="add"]');
    if(mainButton){mainButton.disabled=!available;mainButton.textContent=available?'Add to cart':'Sold out';}

    var stickyPrice=root.querySelector('.abc-stickybar__price');
    if(stickyPrice)stickyPrice.textContent=compare?price+'  '+compare:price;
    var stickyButton=root.querySelector('[data-sticky-bar] button[name="add"]');
    if(stickyButton){
      stickyButton.disabled=!available;
      var stickyText=stickyButton.querySelector('.abc-stickybar__btntxt');
      var stickyBtnPrice=stickyButton.querySelector('.abc-stickybar__btnprice');
      if(stickyText)stickyText.textContent=available?'Add to cart':'Sold out';
      if(stickyBtnPrice)stickyBtnPrice.textContent=available?price:'';
      if(!stickyText&&!stickyBtnPrice)stickyButton.textContent=available?'Add to cart':'Sold out';
    }

    try{
      var u=new URL(window.location.href);
      u.searchParams.set('variant',String(variant.id));
      window.history.replaceState({},'',u.toString());
    }catch(e){}
  }

  var rubik=root.querySelector('.abc-buybox__rubik');
  var mainForm=root.querySelector('.abc-buybox__form');
  if(rubik&&mainForm){
    var productJsonUrl=window.location.pathname.replace(/\/$/,'')+'.js';
    fetch(productJsonUrl,{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('Product JSON unavailable');return r.json();})
      .then(function(productData){
        if(!productData||!productData.variants||productData.variants.length<2)return;

        var currentInput=mainForm.querySelector('input[name="id"]');
        var currentId=currentInput?String(currentInput.value):'';
        var selected=productData.variants.filter(function(v){return String(v.id)===currentId;})[0];
        if(!selected)selected=productData.variants.filter(function(v){return v.available;})[0]||productData.variants[0];

        var picker=document.createElement('fieldset');
        picker.className='abc-variant-picker';
        picker.setAttribute('aria-label','Choose an option');

        var legend=document.createElement('legend');
        legend.className='abc-visually-hidden';
        legend.textContent='Choose an option';
        picker.appendChild(legend);

        function syncCards(){
          picker.querySelectorAll('[data-abc-variant-card]').forEach(function(card){
            var input=card.querySelector('input[type="radio"]');
            card.classList.toggle('is-selected',!!(input&&input.checked));
          });
        }

        productData.variants.forEach(function(variant){
          var card=document.createElement('label');
          card.className='abc-variant-card'+(variant.available?'':' is-disabled');
          card.setAttribute('data-abc-variant-card','');

          var input=document.createElement('input');
          input.type='radio';
          input.name='abc-variant-'+productData.id;
          input.value=String(variant.id);
          input.setAttribute('aria-label',variant.title+' '+formatMoney(variant.price));
          input.disabled=!variant.available;
          input.checked=String(variant.id)===String(selected.id);

          var check=document.createElement('span');
          check.className='abc-variant-card__check';
          check.setAttribute('aria-hidden','true');

          var title=document.createElement('span');
          title.className='abc-variant-card__title';
          title.textContent=variant.title;

          var price=document.createElement('span');
          price.className='abc-variant-card__price';
          price.textContent=formatMoney(variant.price);

          card.appendChild(input);
          card.appendChild(check);
          card.appendChild(title);
          card.appendChild(price);
          picker.appendChild(card);

          input.addEventListener('change',function(){
            if(!input.checked)return;
            syncCards();
            setVariant(variant);
          });
        });

        syncCards();
        rubik.insertBefore(picker,rubik.firstChild);
        setVariant(selected);
      })
      .catch(function(){/* Single-variant and inaccessible draft products keep the server-rendered form. */});
  }

  if(!document.getElementById('abc-variant-picker-style')){
    var style=document.createElement('style');
    style.id='abc-variant-picker-style';
    style.textContent='.abc-variant-picker{border:0;margin:10px 0 4px;padding:0;display:grid;gap:12px;width:100%;min-width:0}.abc-variant-card{position:relative;display:grid;grid-template-columns:44px minmax(0,1fr) auto;align-items:center;gap:16px;width:100%;min-height:76px;padding:14px 22px;border:0;border-radius:22px;background:#f1f2f6;color:#a1a6b7;cursor:pointer;transition:background .18s ease,color .18s ease,transform .12s ease}.abc-variant-card:hover:not(.is-disabled){transform:translateY(-1px);background:#e9edf5}.abc-variant-card input{position:absolute;inset:0;width:100%;height:100%;margin:0;opacity:0;cursor:pointer}.abc-variant-card:focus-within{outline:3px solid rgba(3,66,236,.25);outline-offset:2px}.abc-variant-card__check{width:44px;height:44px;border:3px solid #c3c7d4;border-radius:13px;background:#fff;display:flex;align-items:center;justify-content:center;box-sizing:border-box;transition:background .18s ease,border-color .18s ease}.abc-variant-card__check:after{content:"";width:12px;height:21px;border:solid #fff;border-width:0 4px 4px 0;transform:rotate(45deg) translate(-1px,-2px);opacity:0}.abc-variant-card__title{min-width:0;font-weight:700;font-size:1.8rem;line-height:1.15;letter-spacing:-.015em}.abc-variant-card__price{font-weight:800;font-size:1.8rem;line-height:1;letter-spacing:-.02em;white-space:nowrap;text-align:right}.abc-variant-card.is-selected{background:#e7efff;color:#0642c7}.abc-variant-card.is-selected .abc-variant-card__check{background:#0642c7;border-color:#0642c7}.abc-variant-card.is-selected .abc-variant-card__check:after{opacity:1}.abc-variant-card.is-disabled{opacity:.48;cursor:not-allowed}.abc-variant-card.is-disabled input{cursor:not-allowed}@media(max-width:749px){.abc-variant-picker{gap:10px}.abc-variant-card{grid-template-columns:38px minmax(0,1fr) auto;gap:12px;min-height:66px;padding:12px 16px;border-radius:18px}.abc-variant-card__check{width:38px;height:38px;border-radius:11px}.abc-variant-card__check:after{width:10px;height:18px;border-width:0 3px 3px 0}.abc-variant-card__title{font-size:1.8rem}.abc-variant-card__price{font-size:1.8rem}}';
    document.head.appendChild(style);
  }

  var bar=root.querySelector('[data-sticky-bar]');
  var anchor=root.querySelector('[data-atc-anchor]');
  if(bar&&anchor&&'IntersectionObserver'in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){bar.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0);});
    },{threshold:0});
    io.observe(anchor);
  }
})();
